
type SessionStoreValue = string | null;


export const SESSION_KEYS = {
  SELECTED_CLASS: 'SELECTED_CLASS',
}

export const parseSessionValue = (data: any): any => {
  try {
    return JSON.parse(data);
  } catch (e) {
    return data;
  }
}

export const setSessionValue = (key: string, value: SessionStoreValue): void => {
  sessionStorage.setItem(key, value || '');
};

export const getSessionValue = (key: string): SessionStoreValue => {
  const storedValue = sessionStorage.getItem(key);
  return storedValue;
};

export const removeSessionValue = (key: string): void => {
  sessionStorage.removeItem(key);
};



